export const refreshTimetable = () => {
  // For some reason, to update the timeline, we need to fire a resize event
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 0);
};
